module.exports = __webpack_public_path__ + "static/media/smile.c48c5668.svg";